module.exports = __webpack_public_path__ + "static/media/transparent_logo.49702f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/main/transparent_logo.png
// module id = 973
// module chunks = 124